
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import SiteAddressFields from '@/components/ui/site-address-fields';
import { EstimateFormValues } from '../types/estimateFormTypes';

interface EstimateAdditionalFieldsProps {
  form: UseFormReturn<EstimateFormValues>;
}

const EstimateAdditionalFields: React.FC<EstimateAdditionalFieldsProps> = ({ form }) => {
  return (
    <div className="space-y-6">
      <SiteAddressFields form={form} />
    </div>
  );
};

export default EstimateAdditionalFields;
